import { styled } from '@goodfynd/react-web.theme';

import { ReviewText } from '../../ReviewText';

export const StyledReviewContainer = styled('div', {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  margin: '0 auto',
  maxWidth: 425,
  padding: 24,
});

export const StyledReviewText = styled(ReviewText, {
  fontSizeRem: 12,
  lineHeightRem: 21,
});

export const StyledRow = styled('div', {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center',
});
